export default __webpack_public_path__ + "static/media/curated_online_courses.1f0dcd19.png";